import { useState, useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import { Icon } from '../common'
import { pageTitle } from '../../utils/navigation'

function getTheme(): 'dark' | 'light' {
  return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark'
}

interface HeaderProps {
  onMenuToggle: () => void
}

export function Header({ onMenuToggle }: HeaderProps) {
  const location = useLocation()
  const [theme, setTheme] = useState<'dark' | 'light'>(getTheme)

  const title = pageTitle(location.pathname)

  const toggleTheme = useCallback(() => {
    const next = theme === 'dark' ? 'light' : 'dark'
    const apply = () => {
      if (next === 'dark') {
        delete document.documentElement.dataset.theme
        localStorage.removeItem('theme')
      } else {
        document.documentElement.dataset.theme = next
        localStorage.setItem('theme', next)
      }
      const meta = document.querySelector('meta[name="theme-color"]')
      if (meta) meta.setAttribute('content', next === 'light' ? '#f4f5f7' : '#141824')
      setTheme(next)
    }
    if (document.startViewTransition) {
      document.startViewTransition(apply)
    } else {
      document.documentElement.classList.add('theme-transition')
      apply()
      setTimeout(() => document.documentElement.classList.remove('theme-transition'), 300)
    }
  }, [theme])

  return (
    <header className="top-header">
      <div className="header-left">
        <button
          className="mobile-menu-toggle"
          onClick={onMenuToggle}
          aria-label="Toggle navigation menu"
        >
          <Icon name="menu" size={20} />
        </button>
        <h1 className="header-title">{title}</h1>
      </div>
      <div className="header-right">
        <button
          className="btn-theme"
          onClick={toggleTheme}
          title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          aria-label="Toggle theme"
        >
          {theme === 'dark' ? <Icon name="sun" size={16} /> : <Icon name="moon" size={16} />}
        </button>
      </div>
    </header>
  )
}
